import { type FC } from 'react';
import styles from '../styles/error-message.module.scss';

const ErrorMessage: FC<{
    className?: string;
    message: string;
}> = ({ className = '', message }) => {
    return (
        <div className={`${styles.errorMessage} ${className}`} role="alert">
            {message}
        </div>
    );
};

export default ErrorMessage;
